import React from "react";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { ROUTES } from "../../constants";
import ImageLogoDark from "../../images/logo-dark.png";
import "./styles.css";

function FooterWebsite() {
  return (
    <Box
      className="footer"
      as="footer"
      sx={{
        padding: {
          xs: "2rem 0",
          md: "3rem 0",
        },
      }}
    >
      <Grid container className="container" spacing={1}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              width: {
                xs: "240px",
                md: "200px",
              },
            }}
          >
            <img src={ImageLogoDark} />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Grid container spacing={1}>
            {/* <Grid
              item
              xs={12}
              md={6}
              sx={{
                paddingBottom: {
                  xs: "1rem",
                  md: "0",
                },
                display: "flex",
                alignItems: "center",
              }}
            >
              <Link to={`${ROUTES.WEBSITE_HOME}`}>Services</Link>
            </Grid> */}
            <Grid item xs={12} md={6}>
              <Link to={`${ROUTES.WEBSITE_ABOUT}`}>Why Rentbeets</Link>
              {/* Renbeets */}
              {/* <ul>
                <li>
                  <a href="#why">Why Rentbeets</a>
                </li>
              </ul> */}
            </Grid>
            <Grid item xs={12} md={6}>
              <Link
                to='#'
                onClick={(e) => {
                    window.location.href = "mailto:support@rentbeets.com";
                    e.preventDefault();
                }}
              >
                {'support@rentbeets.com'}
            </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default FooterWebsite;
